import { safePost } from '@mo/mo-safe-request';
import { ServiceUnavailableError } from '../../common/errors';
import { apiUrl } from '../../common/gateway';
import { AuthRedirect } from '../../domain/AuthFlowState';
import {
    AccountLockedError,
    GENERIC_PING_PASSWORD_ERROR,
    PasswordValidationErrors,
    UnauthorisedError,
} from '../../common/passwordValidation/errors';

export async function changePassword(username: string, existingPassword: string, newPassword: string): Promise<void> {
    return await throwingChangePasswordErrors(
        (): Promise<AuthRedirect> =>
            safePost(apiUrl(`auth/changePassword`, 'v1'), { username, existingPassword, newPassword })
    );
}

export async function resetPassword(username: string, existingPassword: string, newPassword: string): Promise<void> {
    return await throwingChangePasswordErrors(
        (): Promise<AuthRedirect> =>
            safePost(apiUrl(`auth/resetPassword`, 'v1'), { username, existingPassword, newPassword })
    );
}

export async function throwingChangePasswordErrors(fn: () => Promise<AuthRedirect>): Promise<void> {
    try {
        await fn();
    } catch (error: any) {
        if (error.response.status === 401) {
            throw new UnauthorisedError();
        }
        if (error.response.status === 403) {
            throw new AccountLockedError();
        } else if (error.response.status === 400) {
            throw new PasswordValidationErrors('Password validation error', [GENERIC_PING_PASSWORD_ERROR]);
        }
        throw new ServiceUnavailableError();
    }
}
